var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobilePhoneCrossed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5209_11534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45508 0.0429688C5.04102 0.140625 4.66992 0.449219 4.47461 0.859375L4.35352 1.11328V10V18.8867L4.47461 19.1406C4.62695 19.4648 4.86914 19.707 5.19336 19.8594L5.44727 19.9805H9.99805H14.5488L14.8027 19.8594C15.127 19.707 15.3691 19.4648 15.5215 19.1406L15.6426 18.8867V10V1.11328L15.5215 0.859375C15.3691 0.535156 15.127 0.292969 14.8027 0.140625L14.5488 0.0195312L10.0762 0.0117188C7.55273 0.0078125 5.54102 0.0234375 5.45508 0.0429688ZM12.1855 0.957031C12.2129 0.992188 12.2441 1.10156 12.252 1.20312C12.2676 1.35156 12.2559 1.41016 12.1855 1.49219L12.1035 1.60156H10.0176C8.02539 1.60156 7.93164 1.59766 7.8457 1.52734C7.76758 1.46484 7.75195 1.41406 7.75195 1.23828C7.75195 0.871094 7.56836 0.898438 9.99805 0.898438C11.873 0.898438 12.1426 0.90625 12.1855 0.957031ZM14.5684 8.92578V15.3906H9.99805H5.42773V8.92578V2.46094H9.99805H14.5684V8.92578ZM10.4199 16.8203C10.8691 17.043 11.0449 17.5938 10.8145 18.0508C10.4824 18.7148 9.51367 18.7148 9.18164 18.0508C8.86914 17.4336 9.31055 16.7188 9.99805 16.7188C10.1543 16.7188 10.2754 16.7461 10.4199 16.8203Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.84375,
    width: 1.25,
    height: 26.9124,
    rx: 0.625,
    transform: "rotate(-44.0792 0.015625 0.84375)",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5209_11534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhoneCrossed);
export default __webpack_public_path__ + "static/media/mobile-phone-crossed.23f087d9435560322066cb882d1ae0b9.svg";
export { ForwardRef as ReactComponent };